import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Loader2, KeyRound, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const isReader = params.get('tipo') === 'leitor';
  const [form, setForm] = useState({ next: '', confirm: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.next.length < 6) return setError('A nova senha deve ter pelo menos 6 caracteres');
    if (form.next !== form.confirm) return setError('As senhas não coincidem');
    setSaving(true);
    try {
      const { data } = await axios.post(`${API}/auth/reset-password`, { token, new_password: form.next });
      setDone(data.message);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Link inválido ou expirado. Peça um novo link de redefinição.');
    } finally {
      setSaving(false);
    }
  };

  const loginPath = isReader ? '/leitor/login' : '/login';

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1a1f2e 0%, #2d3748 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div data-testid="reset-password-card" style={{ background: 'white', borderRadius: 16, padding: '2rem' }}>
          <img src="/livrum-logo.webp" alt="Livrum" style={{ height: '44px', width: 'auto', marginBottom: '1.25rem' }} />
          {done ? (
            <>
              <p data-testid="reset-password-done" style={{ display: 'flex', gap: '0.6rem', color: '#2f855a', fontWeight: 600, marginBottom: '1.25rem' }}>
                <CheckCircle2 className="w-5 h-5" style={{ flexShrink: 0 }} /> {done}
              </p>
              <Button onClick={() => navigate(loginPath)} style={{ width: '100%', background: '#68AAB0' }} data-testid="reset-password-go-login">Ir para o login</Button>
            </>
          ) : !token ? (
            <p data-testid="reset-password-invalid" style={{ color: '#c53030' }}>Link inválido. Peça um novo link em "Esqueci minha senha".</p>
          ) : (
            <form onSubmit={submit}>
              <h1 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.25rem', fontWeight: 700, color: '#2d3748', marginBottom: '1rem' }}>
                <KeyRound className="w-5 h-5" style={{ color: '#68AAB0' }} /> Criar nova senha
              </h1>
              {error && <p data-testid="reset-password-error" style={{ color: '#c53030', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{error}</p>}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div><Label htmlFor="rp-new">Nova senha</Label><Input id="rp-new" type="password" required value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} data-testid="reset-password-new" /></div>
                <div><Label htmlFor="rp-confirm">Confirmar nova senha</Label><Input id="rp-confirm" type="password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="reset-password-confirm" /></div>
              </div>
              <Button type="submit" disabled={saving} style={{ width: '100%', marginTop: '1.25rem', background: '#68AAB0' }} data-testid="reset-password-submit">
                {saving && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Salvar nova senha
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
